/* eslint-disable */
/* tslint:disable */

import React from 'react';
import { ReactECharts, ReactEChartsProps } from '../../echarts/echarts';

function getChartOption(param: IndicatorChartProps) {
  const option = {
    radar: {
      // shape: 'circle',
      indicator: param.indicator && param.indicator?.length > 0 ? param.indicator : [{ name: '', max: 1 }],
      radius: 80,
      center: ['50%', '50%'],
      axisName: {
        padding: [-10, -15],
      },
    },
    series: [
      {
        type: 'radar',
        symbol: 'none',
        itemStyle: {
          normal: {
            areaStyle: {},
          },
        },
        data: [
          {
            value: param.values && param.values?.length > 0 ? param.values : [],
          },
        ],
      },
    ],
  };
  return option;
}

const style = {
  height: '300px',
  width: '300px',
};

export interface IndicatorChartProps {
  indicator?: any[];
  values?: any[];
}

const IndicatorChartBlock: React.FC<IndicatorChartProps> = (props) => {
  return (
    <>
      <ReactECharts option={getChartOption(props) as any} style={style} />
    </>
  );
};

export default IndicatorChartBlock;
